import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Components, utils } from 'zero';

const { Input, Button } = Components;
const { array: arrayUtils } = utils;

class InputButton extends Component {
  constructor(props) {
    super(props);
    this.inputs = [];
    this.state = {
      value: props.value.split(',')
    };
    this.addInput = this.addInput.bind(this);
    this.removeInput = this.removeInput.bind(this);
    this.setInputValue = this.setInputValue.bind(this);
    this.getValue = this.getValue.bind(this);
  }

  getValue() {
    return arrayUtils(this.state.value).join(',');
  }

  setInputValue(key, inputValue) {
    const value = this.state.value;
    value.splice(key, 1, inputValue);
    this.setState({ value });
  }

  removeInput(key) {
    const value = this.state.value;
    value.splice(key, 1);
    this.setState({ value });
  }

  addInput() {
    const value = this.state.value;
    value.push('');
    this.setState({ value });
  }

  render() {
    const Inputs = this.state.value.map((value, key) => {
      const inputKey = `${key}`;
      return (
        <div key={inputKey}>
          <Input
            style={{ margin: '5px 5px 0px 0px' }}
            onChange={(event, context, inputValue) => this.setInputValue(key, inputValue)}
            {...this.props}
            value={value}
            type={this.props.inputType}
            valid={this.props.inputValid}
          />
          <Button text="删除" type={['small']} onClick={() => this.removeInput(key)} />
        </div>
      );
    });

    return (
      <div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: '-5px' }}>
        <Button
          text="添加"
          type={['small']}
          onClick={this.addInput}
        />
        <br />
        {
          Inputs
        }
      </div>
    );
  }
}

InputButton.propTypes = {
  inputType: PropTypes.string,
  inputValid: PropTypes.string,
  value: PropTypes.string,
};


InputButton.defaultProps = {
  inputType: 'number',
  inputValid: 'number',
  value: '',
};

export default InputButton;



// WEBPACK FOOTER //
// ./example/src/page/creditProductEdit/InputButton/index.js